import { Globe, Star, Users, PhoneIncoming, Target, Sparkles } from "lucide-react";

const items = [
  { icon: Globe, label: "Website conversion review" },
  { icon: Star, label: "Google Business Profile & reviews audit" },
  { icon: Users, label: "New-patient visibility check" },
  { icon: Sparkles, label: "AI visibility & search-readiness snapshot" },
  { icon: PhoneIncoming, label: "Lead-to-appointment flow analysis" },
  { icon: Target, label: "3 priority recommendations" },
];

const CheckupWhatYouGet = () => (
  <section id="what-you-get" className="py-14 md:py-20 bg-background">
    <div className="max-w-4xl mx-auto section-padding">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight mb-3">
          What You'll Get
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          You will receive a concise growth checkup that highlights where your practice may be losing visibility, inquiries, or scheduled new patients. We focus on the biggest friction points first so you can see what deserves attention next.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mb-10">
        {items.map((item) => (
          <div key={item.label} className="flex items-start gap-3 bg-card rounded-xl p-5 border border-border">
            <item.icon className="w-5 h-5 text-accent shrink-0 mt-0.5" />
            <span className="text-sm font-medium text-foreground">{item.label}</span>
          </div>
        ))}
      </div>

      {/* AI visibility callout */}
      <div className="bg-accent/10 rounded-2xl p-6 md:p-8 border border-accent/20 mb-6">
        <div className="flex items-start gap-4">
          <Sparkles className="w-6 h-6 text-accent shrink-0 mt-0.5" />
          <div>
            <h3 className="text-lg font-bold text-foreground mb-2">AI Visibility Snapshot — Included</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">
              AI-powered search is changing how patients find dentists. We check whether your practice shows up in AI answers from Google, ChatGPT, and other emerging tools — and flag what you can do now to stay ahead.
            </p>
          </div>
        </div>
      </div>

      {/* What this is really for */}
      <div className="bg-muted rounded-2xl p-6 md:p-8 border border-border">
        <h3 className="text-lg font-bold text-foreground mb-3">This Is Not a Generic Marketing Audit</h3>
        <p className="text-muted-foreground text-sm leading-relaxed">
          Most practices do not need more random tactics. They need to know where the current system is breaking down. Sometimes the issue is visibility. Sometimes it is the website. Sometimes the problem sits in the handoff between traffic, phone calls, forms, and scheduling. The point of this checkup is to show you where the bottleneck is — in plain English — so you can make a better next decision.
        </p>
      </div>
    </div>
  </section>
);

export default CheckupWhatYouGet;
